import type { ActivatedRoute, Router } from '@angular/router';
import { isUuid } from '@sankarah/shared-util';
import { parseCommunityIdFromUrl } from './parse-community-id-from-url';

/**
 * 祖先ルートの `:communityId` を返す。
 * **`router` を渡すと `Router.url` を優先**（同一コンポーネント再利用時、`ActivatedRoute.snapshot` だけでは `:communityId` が更新されないことがある）。
 */
export function communityIdFromRoute(
  route: ActivatedRoute,
  router?: Pick<Router, 'url'>,
): string | null {
  if (router) {
    const path = router.url.split('?')[0] ?? '';
    if (/\/communities\/[^/]+\/community-closed\/?$/.test(path)) {
      return null;
    }
    const fromUrl = parseCommunityIdFromUrl(router.url);
    if (fromUrl) return fromUrl;
  }
  let r: ActivatedRoute | null = route;
  while (r) {
    const id = r.snapshot.paramMap.get('communityId');
    if (id && isUuid(id)) return id;
    r = r.parent;
  }
  return null;
}
